import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { UserPlus } from "lucide-react";
import DomainElements from "@/components/gsa/DomainElements";
import { Domain } from "@/types/domain";
import KnowledgeNetworkStats from "@/components/gsa/KnowledgeNetworkStats";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

// Education domain elements
const domains: Domain[] = [{
  symbol: "K-12 Education",
  name: "K-12 Education",
  categories: "Curriculum Development, Educational Technology Integration, School Administration, Teacher Professional Development, Student Assessment Methods, Special Education Services"
}, {
  symbol: "Higher Education",
  name: "Higher Education",
  categories: "University Governance, Academic Research Administration, Student Services Management, Campus Infrastructure Planning, Educational Accreditation, Graduate Program Development"
}, {
  symbol: "Educational Equity",
  name: "Educational Equity",
  categories: "Diversity & Inclusion Programs, Educational Access Initiatives, Civil Rights Compliance, English Language Learner Support, Socioeconomic Disparity Mitigation, Disability Accommodation"
}, {
  symbol: "Education Grants",
  name: "Education Grants",
  categories: "Federal Student Aid Programs, School Improvement Grants, Research Funding Management, STEM Education Initiatives, Education Innovation Grants, Formula Grant Distribution"
}, {
  symbol: "Education Policy",
  name: "Education Policy",
  categories: "Federal Education Legislation, Regulatory Compliance, State Education Agency Relations, Policy Implementation Strategies, Legislative Analysis, Accountability Systems"
}, {
  symbol: "Education Data",
  name: "Education Data",
  categories: "Student Achievement Metrics, Educational Research Methods, Statistical Analysis for Education, Data Privacy and Security, Longitudinal Data Systems, National Assessment Programs"
}];
const networkStats = {
  totalParticipants: 978,
  activeContributors: 412,
  knowledgeBases: 723,
  totalSolutions: 215,
  departments: [{
    name: "Office of Elementary and Secondary Education",
    participants: 312
  }, {
    name: "Office of Postsecondary Education",
    participants: 245
  }, {
    name: "Office of Special Education Programs",
    participants: 164
  }, {
    name: "Office of Educational Technology",
    participants: 97
  }, {
    name: "Other Dept. of Education Offices",
    participants: 160
  }]
};
const DeptEducationChannel = () => {
  return <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Card className="mb-6">
          <CardHeader>
            <div className="flex items-center gap-6">
              <img src="/lovable-uploads/96fa6c65-feaa-4c8e-a94f-eaa594519caf.png" alt="US Federal Government Giblet" className="w-28 h-28 object-contain" />
              <div className="flex-grow">
                <CardTitle className="text-2xl font-bold mb-2">US Agency Channel</CardTitle>
                <CardDescription className="text-lg">
                  The place where former federal employees impacted by Department of Government Efficiency (DOGE) cuts continue to serve the American people
                </CardDescription>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-3">
                    <Link to="/gsa-channel">
                      <img src="/lovable-uploads/3e0cc269-0dd5-40b5-a1f0-0ebbe7e85733.png" alt="GSA Giblet" className="w-12 h-12 object-contain hover:scale-110 transition-transform cursor-pointer" title="General Services Administration" />
                    </Link>
                    <Link to="/dept-education-channel">
                      <img src="/lovable-uploads/79ab86f8-bc15-4c23-aa17-3b68e2637276.png" alt="DoE Giblet" className="w-12 h-12 object-contain hover:scale-110 transition-transform cursor-pointer" title="Department of Education" />
                    </Link>
                    <Link to="/noaa-channel">
                      <img src="/lovable-uploads/bab08742-8e14-4791-9d8d-dc0b1fd81a3a.png" alt="NOAA Giblet" className="w-12 h-12 object-contain hover:scale-110 transition-transform cursor-pointer" title="National Oceanic and Atmospheric Agency" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Department of Education Dashboard</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="col-span-2">
                  <KnowledgeNetworkStats stats={networkStats} />
                </div>
                <div className="flex flex-col gap-4">
                  <Card className="p-3 bg-blue-50">
                    <div className="flex items-center space-x-3 mb-2">
                      <Avatar className="h-12 w-12 border-2 border-blue-500">
                        <AvatarImage src="/lovable-uploads/a1ad3186-f15d-4670-8b93-388a6ed7979f.png" alt="Mike Mosher" className="object-cover" />
                        <AvatarFallback className="bg-blue-100 text-blue-800 text-xl">MM</AvatarFallback>
                      </Avatar>
                      <div>
                        <h3 className="text-lg font-semibold">Network Ambassador</h3>
                        <Link to="/mike-mosher-profile" className="text-primary hover:text-primary/80 font-medium">
                          Mike Mosher
                        </Link>
                        <p className="text-sm text-gray-600">Former Director of Educational Technology</p>
                      </div>
                    </div>
                    <p className="text-sm text-gray-700 mb-2">
                      Building networks across former Department of Education specialists to continue supporting educational initiatives nationwide.
                    </p>
                    <Button variant="outline" size="sm" className="w-full">
                      <UserPlus className="mr-2 h-4 w-4" />
                      Join Knowledge Network
                    </Button>
                  </Card>
                </div>
              </div>
            </div>
            
            <div className="mt-8">
              <h2 className="text-xl font-semibold mb-4">Department of Education Domain Elements</h2>
              <DomainElements domains={domains} />
            </div>
          </CardContent>
        </Card>
      </main>
    </div>;
};
export default DeptEducationChannel;
